export default {
  title: "Каталог",
  chooserLead:
    "Авторитетный каталог лиц, произведений, изданий и премий. Ищите по фасетам или подбирайте по условиям.",
  modeSearch: "Поиск по каталогу",
  modeQuery: "Подбор по условиям",
  modeSearchHint: "Свободный текст, фасеты, сортировка",
  modeQueryHint: "Сценарии: автор, издатель, премия…",
  openSearch: "Открыть поиск",
  openQuery: "Открыть подбор",
  quickSearchPlaceholder: "Автор, заглавие, ISBN…",
  quickSearchSubmit: "Найти",
  switchToQuery: "Нужен точный подбор? →",
  switchToSearch: "Быстрее искать словами? →",
  modeTabsAria: "Режим каталога",
  viewAria: "Вид каталога",
  viewSimple: "Простой",
  viewExpert: "Полный",
}
